import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';

import { Provider } from 'react-redux';
import { store } from './redux/store';

import './index.css';

if (process.env.REACT_APP_BUGSINK_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_BUGSINK_DSN,
    environment: process.env.NODE_ENV || 'production',
    release: process.env.REACT_APP_VERSION || 'unknown',
    tracesSampleRate: 0,
    autoSessionTracking: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (
      <div style={{ padding: 24, fontFamily: 'system-ui' }}>
        <h1>Something went wrong.</h1>
        <p>The error has been reported. You can try to <button onClick={resetError}>reload this view</button>.</p>
      </div>
    )}
  >
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);
